import { render } from "./ConnectWalletModal.vue?vue&type=template&id=f42c4164&scoped=true"
import script from "./ConnectWalletModal.vue?vue&type=script&lang=js"
export * from "./ConnectWalletModal.vue?vue&type=script&lang=js"

import "./ConnectWalletModal.vue?vue&type=style&index=0&id=f42c4164&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f42c4164"]])

export default __exports__